import { useParams } from 'react-router-dom';
import { initialBatchConfigurationFormState } from '../types/BatchConfigType';
import BatchConfigurationForm from './BatchConfigurationForm';
import EditBatchConfigurationForm from './EditBatchConfigurationForm';
import { usePreFormBatchConfiguration } from '../hooks/usePreFormBatchConfiguration';

export default function BatchConfigurationFormContainer() {
  const { batchConfigurationId, assetId } = useParams<{ batchConfigurationId?: string, assetId: string }>();
  const { preFormBatchConfiguration } = usePreFormBatchConfiguration();
  if (batchConfigurationId) {
    return (
      <EditBatchConfigurationForm
        key={batchConfigurationId}
        batchConfigurationId={batchConfigurationId}
        preFormBatchConfiguration={preFormBatchConfiguration}
        assetId={assetId || ''}
      />
    );
  }

  return (
    <BatchConfigurationForm
      initialFormData={{
        ...initialBatchConfigurationFormState,
        assetId: assetId || '',
      }}
      preFormBatchConfiguration={preFormBatchConfiguration}
      assetId={assetId || ''}
    />
  );
}
